import { render, staticRenderFns } from "./SessionsPerCoachTable.vue?vue&type=template&id=ceb4c3b6&scoped=true"
import script from "./SessionsPerCoachTable.vue?vue&type=script&lang=ts"
export * from "./SessionsPerCoachTable.vue?vue&type=script&lang=ts"
import style0 from "./SessionsPerCoachTable.vue?vue&type=style&index=0&id=ceb4c3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb4c3b6",
  null
  
)

export default component.exports